import { PREMIUM_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

// TODO - Change this to be gated behind ARJ entitlement, not JSW Premium
// However, JSW Premium does give ARJ entitlement so technically this is correct.
export const useHasSetParentEntitlementForAboveLevelOne = () => {
	const { software } = useAppEditions();
	return software === PREMIUM_EDITION;
};
